import { render, staticRenderFns } from "./ManageLoyalty.vue?vue&type=template&id=f7a96c88&"
import script from "./ManageLoyalty.vue?vue&type=script&lang=ts&"
export * from "./ManageLoyalty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports